/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-07 14:20.
 */
const Pagination = {
  init( root, count, pageSize = 'pageSize', pageNo = 'pageNo', searchFun = 'search' ) {
    const that = this;
    const $root = $( root );
    const sources = ( function() {
      let result = [];
      count > 9900 && ( count = 9900 );
      for (let i = 0; i < count; i ++) {
        result.push( i );
      }
      return result;
    } )();
    that[ pageSize ] = $root.find( '.pagination-container .page-size' ).val() || that[ pageSize ] || 15;
    /* eslint-disable */
    const options = {
      dataSource: sources,
      totalNumber: count,
      pageSize: that[ pageSize ],
      pageNumber: that[ pageNo ],
      prevText: '<',
      nextText: '>',
      showGoInput: true,
      showGoButton: true,
      beforeGoButtonOnClick: ( event, pageNumber ) => {
        let lastPageNo = $( '.paginationjs-last' ).data( 'num' );
        if (! lastPageNo) {
          lastPageNo = $( '.J-paginationjs-page:last' ).data( 'num' );
        }
        if (pageNumber > lastPageNo) {
          alert( '跳转页数不得大于最大页数' );
          return;
        }
        if (pageNumber >= 1) {
          that[ pageNo ] = pageNumber;
          that[ searchFun ]();
        }
      },
      beforePageOnClick: ( event, pageNumber ) => {
        that[ pageNo ] = pageNumber;
        that[ searchFun ]();
      },
      beforeGoInputOnEnter: ( event, pageNumber ) => {
        let lastPageNo = $( '.paginationjs-last' ).data( 'num' );
        if (! lastPageNo) {
          lastPageNo = $( '.J-paginationjs-page:last' ).data( 'num' );
        }
        if (! /^\d+$/.test( pageNumber ) || pageNumber > lastPageNo || pageNumber < 1) {
          alert( '跳转页数不合法' );
          return;
        }
        that[ pageNo ] = pageNumber;
        that[ searchFun ]();
      },
      beforePreviousOnClick: () => {
        that[ pageNo ] --;
        that[ searchFun ]();
      },
      beforeNextOnClick: () => {
        that[ pageNo ] ++;
        that[ searchFun ]();
      }
    };
    /* eslint-enable */
    $root.find( '.pagination-container .pagination-list' )[ 0 ] && $root.find( '.pagination-container .pagination-list' ).pagination( options );
    $root.find( '.page-size' ).off( 'change' ).on( 'change', ( e ) => {
      const $el = $( e.target || e.srcElement );
      that[ pageSize ] = $el.val();
      that[ pageNo ] = 1;
      that[ searchFun ]();
    } );
  }
};

module.exports = Pagination;
